import TreeView from "@mui/material/Avatar";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <TreeView key={component.id} />;
}

export default Component;
